const state = {
  formName: '',
  formEmail: '',
};

const mutations = {
  setName(localState, newName) {
    localState.formName = newName;
  },
  setEmail(localState, newEmail) {
    localState.formEmail = newEmail;
  },
};

const actions = {
  selectName({ commit }, formName) {
    commit('setName', formName);
  },
  selectEmail({ commit }, formEmail) {
    commit('setEmail', formEmail);
  },
};

export default {
  mutations,
  actions,
  state,
};
